import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { Message } from '@portal-core/messages/models/message.model';

@CollectionStateSelectors({
  stateType: MessagesState
})
@State<MessagesState>({
  name: MessagesState.source
})
@Service({ autoProvided: false })
export class MessagesState extends CollectionStateBase {
  static override source = 'Messages';
  getSource(): string {
    return MessagesState.source;
  }
}

@Service()
export class MessagesDataService extends CollectionDataServiceBase<Message> {
  protected readonly stateType = MessagesState;
}
